module.exports = __webpack_public_path__ + "img/hovered-layer9.f30e34fd.png";